import { SelectionGroupButtonSize } from 'fronton-react';
import { TRoomsParams } from 'common/types/floor-params.type';

export const getSelectionGroupSize = (screenSize: boolean | undefined): SelectionGroupButtonSize =>
  screenSize ? 's' : 'm';

export const getFormattedSquare = (room: TRoomsParams) => {
  if (room.square === null) {
    return '-';
  }

  if (room.square && room.square % 1 === 0) {
    return room.square?.toFixed(0);
  }

  return room.square?.toFixed(2);
};

export const getClearedRoomParams = (room: TRoomsParams) => ({
  width: String(room.width ?? ''),
  length: String(room.length ?? ''),
  square: String(room.square ?? ''),
  isCalculatedRoomsParamsHasOnlySquare: !room.length && !!room.square,
});
